import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontMerriweather, fontRoboto } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  block-size: 100%;
`;

export const StyledEntityLink = styled(EntityLink)`
  display: flex;
  flex: 1;
  flex-direction: column;

  color: #000000;
`;

export const Content = styled.div``;

export const Headline = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 15px;
  font-family: ${fontMerriweather};
  line-height: 21px;
`;

export const SponsorContainer = styled.div`
  margin-block-start: 12px;
  padding-block: 4px;
  padding-inline: 6px;

  border: 1px solid rgba(0, 0, 0, 0.2);
`;

const SponsorTextStyle = css`
  color: #000000;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
`;

export const SponsorType = styled.div`
  ${SponsorTextStyle};
  opacity: 0.5;
`;

export const SponsorName = styled.div`
  ${SponsorTextStyle};
  font-weight: 700;
`;
